module.exports = __webpack_public_path__ + "img/Z85-X18-中_07.c68c3e0d.jpg";